import { motion } from "framer-motion";
import React from "react";
export interface IBackDropProps {
  children: any;
  onClick: () => void;
}

const BackDrop: React.FC<IBackDropProps> = ({ children, onClick }) => {
  return (
    <motion.div
      onClick={onClick}
      className="backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {children}
    </motion.div>
  );
};

export default BackDrop;
